import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { global } from "./global";
import VueHtmlToPaper from "vue-html-to-paper";
import Print from "vue-print-nb-jeecg";
import vSelect from 'vue-select'

import "./registerServiceWorker";

import { lps } from "./global"; 

axios.defaults.baseURL = global.url;

axios.baseURL2 = global.url2;
axios.lpsURL = global.lps_url;

Vue.config.productionTip = false;

Vue.use(Print);

Vue.use(require("vue-moment"));

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    // 'https://admin.takafulbruneihub.com/assets/css/button.css'
    "https://tbdadmin.takafulbruneihub.com/assets/css/button.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.prototype.$lps = lps;

router.beforeEach((to, from, next) => {
  let allowed = ["login", "auth_otp"];

  if(allowed.includes(to.name) || localStorage.getItem("token")) {
    return next();
  }

  next("/login");
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
